













































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Info extends Vue {
  public name = "Info";

  @Prop()
  public exam!: any;

  protected get proctor(): string {
    return this.exam?.proctor || `&#8212;`;
  }

  private get date() {
    return this.exam?.date;
  }

  private get time() {
    return this.exam?.time;
  }

  private get durationInMinutes() {
    return this.exam?.durationInMinutes || 0;
  }

  private get testingOrganization() {
    return this.exam?.testingOrganization;
  }
}
